/**
 * `/code-review/when` — *When Feluda Reviews* section.
 * Greptile-parity sub-page that owns the auto-review toggle, draft
 * reviews, file change limit, and author excludes.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewWhen() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="whenReview"
        title="When Feluda Reviews"
        subtitle="Configure which pull requests trigger an automatic review."
      />
    </main>
  );
}
